import React, { Component } from "react"
import { Nav, Navbar, NavDropdown } from "react-bootstrap"
import { FaHome, FaUser } from "react-icons/fa"
import { connect } from "react-redux"
//import { toast } from "react-toastify"
import { Action, Dispatch } from "redux"
import { SelectCompany } from "../../actions/WorkforceClinicAction"
import { WorkforceOneUserLogOut } from "../../actions/WorkforceOneLoginActions"
import { AppState, AssignedClinic, WorkforceClinicPortal } from "../../AppState"
import UserAccessSettings from "../../authentication/UserAccessSettings"
import { BuildUserAccess } from "../../authentication/BuildUserAccess"
import UserState from "../../authentication/UserState"
import { BuildUserState } from "../../authentication/BuildUserState"
import { getLoggedInUserName, GetSelectedAssignedClinic, isInPortal, SelectedAccountName, SelectedPortalName } from "../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import { GetSinglePageAppPath } from "../../BaseUrl"
import { getOrphanedResultsCount} from "../../storage/LogInPortals"

import {
  ActivateCompanyRoute,
  ActivatePortalRoute,
  CompanyInformationRoute,
  GlobalParameterRoute,
  Home,
  InviteStatusRoute,
  MyInformationRoute,
  MyOrganizationRoute,
  OrderRoute,
  OrderableServicesRoute,
  OrdersRoute,
  OrphanedResultsRoute,
  OurTeamStatusRoute,
  PermissionsRoute,
  RandomsPersonnelRoute,
  RandomsRoute,
  RegulatoryModeRoute,
  SelectionInboxRoute,
  SiteSearchOptionsRoute,
  SiteSearchRoute,
  GovDonorRoute,
  RandomsGovRoute,
  GovOrderRoute,
  ReportPositiveRoute,
  ReportTestingSummaryRoute,
  ReportSpecimenPositivityRoute,
  ReportDrugDetailRoute,
  ReportDailySummaryRoute,
  ReportIvrCallInComplianceRoute,
  ReportNoShowRoute,
  UserCodesRoute,
  UserLabelsRoute,
  ReportCertificationRenewalRoute,
  ReportCertificationStatusRoute,
  ReportManagementSummaryRoute,
  ReportMISRoute,
  ReportSummaryRoute,
  LocationInformationRoute,
  PortalAdministrationRoute,
  ConfigureOrderDefaultsRoute,
  SendingFacilityRoute,
  ConsortiumsRoute,
  ReportSelectedNotTestedRoute,
  LabResultsReportingRoute,
  ReportUnmergedRandomResultsRoute,
  ReportRegulatoryQualityControlRoute,
  ReportMissingRegModeOrEmpCategoryRoute
} from "../../config/Routes"
import { ChangePasswordModal } from "../Accounts/ChangePassword"
import { NavDropdownHover } from "./NavDropdownHover"
import HasAccessToRoute from "../../authentication/hasAccessToRoute"
import NavMenuLink, {NavMenuLinkWithNumber} from "./NavMenuLink"
import { IsOnTrack } from "../../App";
import { PortalCompanySearch } from "./PortalCompanySearch"

export interface NavMenuProps {
  userAccess: UserAccessSettings
  userState: UserState
  selectedCompany?: string
  visibleCompanies?: WorkforceClinicPortal[]
  LoginName: string
}
export interface NavMenuDispatchProps {
  logout: () => void
  selectCompany: (company: string, companyLink: string) => void
}
export interface NavMenuState {
  showChangePassword: boolean
  orphanedResultsCount: number
}

interface MenuItemSpecification { title: string | React.ReactElement, route: string, render?: (() => React.ReactElement | null | undefined) }

export class NavMenu extends Component<NavMenuProps & NavMenuDispatchProps, NavMenuState> {
  public state: NavMenuState = { showChangePassword: false, orphanedResultsCount: getOrphanedResultsCount() }
  baseUrl = GetSinglePageAppPath()

  buildUrl = (route: string) => `${this.baseUrl}#${route}`
  dropMenuItem = (title: string | React.ReactElement, route: string, bypassPermissionsCheck?: boolean, key?: string) => bypassPermissionsCheck || HasAccessToRoute(route, this.props.userAccess, this.props.userState) ? <NavDropdown.Item key={key} href={this.buildUrl(route)}>{title}</NavDropdown.Item> : null
  dropMenu = (title: string | React.ReactElement, id: string, items?: MenuItemSpecification[], children?: React.ReactFragment, alignRight?: boolean) => {
    const menuItems = items?.map((item, i) => item.render ? item.render() : this.dropMenuItem(item.title, item.route, false, `${item.route}_${i}`)).filter(item => !!item) as React.ReactElement[]
    return (children || menuItems?.length) ? <NavDropdownHover title={title} id={id} alignRight={alignRight}>{menuItems}{children}</NavDropdownHover> : <></>
  }

  onStorageChanged = () => {
    this.setState({ orphanedResultsCount: getOrphanedResultsCount() })
  }

  componentDidMount() {
    window.addEventListener('storage', this.onStorageChanged)
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.onStorageChanged)
  }

  render() {
    const { userAccess, userState } = this.props
    const { orphanedResultsCount } = this.state || 0
    return (<>
      <Navbar bg="dark" variant="dark" expand="lg" id="workforce-navbar" className="workforce-navbar">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <NavMenuLink title={<><FaHome /> Home</>} route={Home} userAccess={userAccess} userState={userState} />
            <NavMenuLinkWithNumber title={"Result Exceptions"} route={OrphanedResultsRoute} userAccess={userAccess} userState={userState} count={orphanedResultsCount} />
            <NavMenuLink title="Donor" route={GovDonorRoute} userAccess={userAccess} userState={userState} />
            {this.dropMenu("Randomization", "randomization-nav-dropdown", [
              { title: "Random Testing", route: RandomsRoute },
              { render: () => HasAccessToRoute(RandomsRoute, userAccess, userState) ? undefined : this.dropMenuItem("Random Testing", RandomsPersonnelRoute, false, "Personnel_key"), title: "", route: "" },
              { title: "Random Donor Testing", route: RandomsGovRoute },
              { title: "Selection Inbox", route: SelectionInboxRoute },
              { title: "Consortiums", route: ConsortiumsRoute },
            ])}
            {this.isShowPortals(this.props) && this.getPortalsMenu(this.props)}
            {!IsOnTrack() && <NavMenuLink title="Order" route={OrderRoute} userAccess={userAccess} userState={userState} />}
            {IsOnTrack() && <NavMenuLink title="Order" route={GovOrderRoute} userAccess={userAccess} userState={userState} />}
            <NavMenuLink title="Site Search" route={SiteSearchRoute} userAccess={userAccess} userState={userState} />
            <NavMenuLink title="Results" route={OrdersRoute} userAccess={userAccess} userState={userState} />
            {IsOnTrack() && this.dropMenu("Reports", "reports-nav-dropdown", [
              { title: "Testing Summary", route: ReportTestingSummaryRoute },
              { title: "Specimen Positivity", route: ReportSpecimenPositivityRoute },
              { title: "Drug Detail", route: ReportDrugDetailRoute },
              { title: "Daily Summary", route: ReportDailySummaryRoute },
              { title: "IVR Call-In Compliance", route: ReportIvrCallInComplianceRoute },
              { title: "No Show", route: ReportNoShowRoute }
            ])}
            {!IsOnTrack() && this.dropMenu("Reports", "reports-nav-dropdown", [
              { title: "Positive Only Report", route: ReportPositiveRoute },
              { title: "Management Summary Report", route: ReportManagementSummaryRoute },
              { title: "MIS Report", route: ReportMISRoute },
              { title: "Selected Not Tested Report", route: ReportSelectedNotTestedRoute },
              { title: "Summary Report", route: ReportSummaryRoute },
              //{ title: "Unmerged Random Results", route: ReportUnmergedRandomResultsRoute },
              { title: "Regulatory Quality Control", route: ReportRegulatoryQualityControlRoute },
              { title: "Missing Reg Mode and/or Employee Category", route: ReportMissingRegModeOrEmpCategoryRoute },
            ])}
            {this.dropMenu("Administration", "administration-nav-dropdown", [
              { title: "User Information", route: OurTeamStatusRoute },
              { title: "Portal Information", route: MyOrganizationRoute },
              { title: "Portal Administration", route: PortalAdministrationRoute },
              { title: "Company Information", route: CompanyInformationRoute },
              { title: "Location Information", route: LocationInformationRoute },
              { title: "Invite Status", route: InviteStatusRoute },
              { title: "Permissions", route: PermissionsRoute },
              { title: "Clinic Search Options", route: SiteSearchOptionsRoute },
              { title: "Global Parameters", route: GlobalParameterRoute },
              { title: "Regulatory Modes", route: RegulatoryModeRoute },
              { title: "Orderable Services", route: OrderableServicesRoute },
              { title: "User Codes", route: UserCodesRoute },
              { title: "User Code Labels", route: UserLabelsRoute },
              { title: "Order Defaults", route: ConfigureOrderDefaultsRoute },
              { title: "Sending Facilities", route: SendingFacilityRoute },
              { title: "Lab Results Reporting", route: LabResultsReportingRoute },
            ])}
          </Nav>
          <Nav className="flex-row">
            <Navbar.Text>{this.props.selectedCompany}</Navbar.Text>
            {this.dropMenu(<><FaUser /> Account</>, "account-nav-dropdown", undefined, <>
              {this.dropMenuItem("My Information", MyInformationRoute, false, "MyInformation_key")}
              <NavDropdown.Item onClick={() => this.showChangePasswordClick()}>Change Password</NavDropdown.Item>
              <NavDropdown.Item onClick={() => this.logoutClick()}>Log Out</NavDropdown.Item>
            </>, true)}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <ChangePasswordModal
        show={this.state.showChangePassword}
        LoginName={this.props.LoginName}
        onSubmit={this.performChangePassword}
        onCancel={this.hideChangePassword} />
    </>)
  }

  getPortalsMenu(props: NavMenuProps & NavMenuDispatchProps) {
    const portals = props.visibleCompanies?.sort((a, b) => (a.ImplementationName || "").localeCompare(b.ImplementationName || "")) || []
    const portalItems = portals.reduce<React.ReactElement[]>((acc, portal, portalIndex) => {

      const portalItem = <NavDropdown.Item
        key={`${portal.ParticipationID}-${portalIndex}`}
        disabled={!portal.Link || portal.ParticipationID === props.userState.selectedPortal?.ParticipationID}
        onClick={() => {
          props.selectCompany(portal.ParticipationID || "", portal.Link || "")
          routeToHome()
        }}>
        {portal.ImplementationName}
      </NavDropdown.Item>

      const accountID = props.userState.selectedCompany?.AccountID || 0
      const parentCompany = portal.AssignedClientDetailsOfClinic.find(item => item.AccountID === accountID && !item.LocationID)
      const assignedClinics = portal.AssignedClientDetailsOfClinic.filter(item => !item.LocationID)
      const showCompaniesSearch = (props.userAccess.isPortalAdmin && assignedClinics.length > 0)  || (assignedClinics.length > 1 && !props.userAccess.isLocationAdmin)
      const key = `${parentCompany?.ParticipationID || ""}`
      const parentCompanyItem = !!parentCompany && !showCompaniesSearch ? <NavDropdown.Item
        key={key}
        disabled={!parentCompany.Link || parentCompany.ParticipationID === props.userState.selectedCompany?.ParticipationID}
        onClick={() => {
          props.selectCompany(parentCompany.ParticipationID || "", parentCompany.Link || "")
          routeToHome()
        }}>
        {parentCompany.ImplementationName} / {parentCompany.Name}
      </NavDropdown.Item> : <React.Fragment key={key}></React.Fragment>

      const clinicItems =
        <NavDropdown.Header key="switch-company-typeahead">
          <PortalCompanySearch
            id={`select-switch-company-${portalIndex}`}
            portal={portal}
            switchCompany={(company) => this.switchCompany(company)}
            showCompaniesSearch={showCompaniesSearch}
            userAccess={props.userAccess}
            userState={props.userState}
          />
        </NavDropdown.Header>

      return acc.concat(portalItem).concat(parentCompanyItem).concat(clinicItems)
    }, [])
    return <NavDropdownHover title="Portals" id="portal-nav-dropdown">{portalItems}</NavDropdownHover>
  }

  switchCompany = (company: AssignedClinic) => {
    this.props.selectCompany(company.ParticipationID, company.Link)
    routeToHome()
  }

  isShowPortals(props: NavMenuProps & NavMenuDispatchProps) {
    const permissions = props.userAccess
    //TODO: 2021-06-19. Yanek Dogel. Research is need check caShowPortal permissions to show portal menu
    if (!permissions.canShowPortal) {
      //return false
    }
    if (permissions.isSiteAdmin) {
      return false
    }
    const portals = props.visibleCompanies || []
    if (portals.length == 0) {
      return false
    }
    if (portals.length > 0) {
      return true
    }
    for (let i = 0; i < portals.length; i++) {
      const portal = portals[i]
      const clinics = portal.AssignedClientDetailsOfClinic || []
      if (clinics.length > 0) {
        return true
      }
    }
    return false

  }

  performChangePassword = () => {
    this.setState({ showChangePassword: false })
    this.logoutClick()
  }

  hideChangePassword = () => {
    this.setState({ showChangePassword: false })
  }

  showChangePasswordClick = () => {
    this.setState({ showChangePassword: true })
  }

  logoutClick = () => {
    window.location.hash = "#/"
    //window.location.search = ""
    this.props.logout()

  }
}

function routeToHome() {
  const baseUrl = GetSinglePageAppPath()
  const redirectUrl = baseUrl + "#"
  window.location.href = redirectUrl
}

function mapStateToProps(state: AppState): NavMenuProps {
  const company = GetSelectedAssignedClinic(state)
  return {
    userAccess: BuildUserAccess(state),
    userState: BuildUserState(state),
    selectedCompany: SelectedPortalName(state) || SelectedAccountName(company) || company?.ImplementationName,
    visibleCompanies: state.Workforce1Companies.visibleCompanies,
    LoginName: getLoggedInUserName(state)
  }
}

function mapDispatchProps(dispatch: Dispatch<Action>): NavMenuDispatchProps {
  return {
    logout: () => (dispatch(WorkforceOneUserLogOut())),
    selectCompany: (company: string, companyLink: string) => {
      dispatch(SelectCompany(company, companyLink))
      // toast.success("Logged in successfully")
    },
  }
}

const ConnectedNavMenu = connect<NavMenuProps, NavMenuDispatchProps, {}, AppState>(mapStateToProps, mapDispatchProps)(NavMenu)
export default ConnectedNavMenu
